import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";

const DEFAULT_POSM_PERMISSION = {
  topCateNewInd: false,
  mainCateNewInd: false,
  subCateNewInd: false,
  goodsNewInd: false,
  warehouseNewInd: false,
  storageNewInd: false,
  grNewInd: false,
  wmNewInd: false,
  giNewInd: false,
  reNewInd: false,
  scNewInd: false,
  grEditInd: false,
  wmEditInd: false,
  giEditInd: false,
  reEditInd: false,
  scEditInd: false,
  showPriceInd: false,
  regionalMapInd: false,
  warehouseMapInd: false,
  giApplicationInd: false,
  giConfirmInd: false,
}

export const POSM_PERMISSION_KEY = {
  NEW_GOODS_TYPE: 'topCateNewInd',
  NEW_DIVISION: 'mainCateNewInd',
  NEW_MODEL: 'subCateNewInd',
  NEW_BASIC_MODEL: 'goodsNewInd',
  NEW_WAREHOUSE: 'warehouseNewInd',
  NEW_STORAGE: 'storageNewInd',
  GOODS_RECEIVE: 'grNewInd',
  GOODS_MOVEMENT: 'wmNewInd',
  GOODS_ISSUE: 'giNewInd',
  GOODS_RETURN: 'reNewInd',
  SCRAP_GOODS: 'scNewInd',
  EDIT_GOODS_RECEIVE: 'grEditInd',
  EDIT_GOODS_MOVEMENT: 'wmEditInd',
  EDIT_GOODS_ISSUE: 'giEditInd',
  EDIT_GOODS_RETURN: 'reEditInd',
  EDIT_SCRAP: 'scEditInd',
  SHOW_PRICING_INFO: 'showPriceInd',
  REGIONAL_MAPPING: 'regionalMapInd',
  WAREHOUSE_MAPPING: 'warehouseMapInd',
  GOODS_ISSUE_APPLICATION: 'giApplicationInd',
  GOODS_ISSUE_CONFIRM: 'giConfirmInd',
}

const POSMAuthorizationModel = {
  posmAuthority: localStorage.getItem('posmAuthority') ? JSON.parse(localStorage.getItem('posmAuthority')) : structuredClone(DEFAULT_POSM_PERMISSION),

  getAuthorityUserByIDList: function () {
    return modelBaseV2.get('/api/posmAuthorization/getByUserId')
      .then((result) => {
        this.posmAuthority = result || structuredClone(DEFAULT_POSM_PERMISSION);
        localStorage.setItem('posmAuthority', JSON.stringify(result))
        return result;
      })
  },

  loadWithPOSMAuthority: function (view, posmRestriction) {
    if (this.posmAuthority != null && this.posmAuthority[posmRestriction] === true) {
      return view;
    }
  },

  getAuthorizationList: function (params) {
    const qs = modelBaseV2.toQueryString(params)
    return modelBaseV2.get(`/api/posmAuthorization/list?${qs}`)
  },

  updateAuthorization: function (body) {
    return modelBaseV2.post('/api/posmAuthorization/save', { body })
  },

  downloadAuthorityList: function (body) {
    body.pageSize = 0;
    const paramsMapping = {
      orderBy: "2",
      pageIndex: "3",
      pageSize: "4",
      sortBy: "24",
    }
    const params = Object.entries(paramsMapping).map(([key, value]) => {
      let attr = body[key];
      return {
        code: value,
        value: attr
          ? Array.isArray(attr)
            ? attr.join('^')
            : attr.toString()
          : ""
      }
    })

    const exportConfig = {
      excelSheetNames: [
        "POSM Authority"
      ],
      storedProcedureCode: "73",
      params
    }
    return modelBaseV2.postDownload('/api/survey/export/tr/file', { body: exportConfig }, 'POSM_AUTHORITY.xlsx');
  },
  isPosmAuthorized: function (posmRestriction) {
    return this.posmAuthority[posmRestriction]
  },
  getUserMovementWarehouseMap: (body) => {
    return modelBaseV2.post('/api/posmAuthorization/getListUserWmMap', { body })
  },
  updateUserMovementWarehouseMap: (body) => {
    return modelBaseV2.post('/api/posmAuthorization/saveUserWmMap', { body })
  },
  downloadUserMovementWarehouseMapExcel: (body) => {
    let filename = `User_Movement_Warehouse_Map_${moment().format('YYYYMMDDHHmmss')}_Report.xlsx`
    let params = [
      { code: "152", value: body.movementType || '' },
      { code: "32", value: body.users },
      { code: "3", value: body.pageIndex.toString() },
      { code: "4", value: body.pageSize.toString() },
    ]

    const exportConfig = {
      excelSheetNames: [
        "User Warehouse Map"
      ],
      storedProcedureCode: "69",
      params
    }
    return modelBaseV2.postDownload('/api/survey/export/tr/file', { body: exportConfig }, filename)
  }
}
export default POSMAuthorizationModel
